import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=a4c9dd6c&scoped=true&"
import script from "./videoItem.vue?vue&type=script&lang=js&"
export * from "./videoItem.vue?vue&type=script&lang=js&"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=a4c9dd6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9dd6c",
  null
  
)

export default component.exports